import React from 'react';
import { QuizProvider, useQuizContext } from './context/QuizContext';
import Welcome from './components/Welcome';
import Registration from './components/Registration';
import Quiz from './components/Quiz';
import Results from './components/Results';
import './styles/globals.css';

// Componente contenedor que renderiza la pantalla correcta según el estado
const AppContent = () => {
  const { currentStep } = useQuizContext();

  // Renderizamos el componente correspondiente según el paso actual
  switch (currentStep) {
    case 0:
      return <Welcome />;
    case 1:
      return <Registration />;
    case 2:
      return <Quiz />;
    case 3:
      return <Results />;
    default:
      return <Welcome />;
  }
};

// Componente principal que envuelve todo en el proveedor de contexto
const App = () => {
  return (
    <QuizProvider>
      <AppContent />
    </QuizProvider>
  );
};

export default App;